import { render, staticRenderFns } from "./StaffShow.vue?vue&type=template&id=12cfdcac&scoped=true&"
import script from "./StaffShow.vue?vue&type=script&lang=js&"
export * from "./StaffShow.vue?vue&type=script&lang=js&"
import style0 from "./StaffShow.vue?vue&type=style&index=0&id=12cfdcac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfdcac",
  null
  
)

export default component.exports